<template>
  <div class="arenda-spatii-container1">
    <app-navigation
      imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
      rootClassName="navigationroot-class-name10"
    ></app-navigation>
    <main class="arenda-spatii-main">
      <div class="arenda-spatii-hero section-container">
        <div class="arenda-spatii-max-width1 max-content-container">
          <div class="arenda-spatii-content-container1">
            <h1 class="arenda-spatii-text10">
              <span>
                COMBINATUL AUTO
                <span v-html="rawaiyu"></span>
              </span>
              <span class="arenda-spatii-text12">nr.4</span>
              <br />
              <span class="arenda-spatii-text14">s</span>
              <span class="arenda-spatii-text15">
                ervicii de
                <span v-html="raw82ll"></span>
              </span>
              <br />
              <span class="arenda-spatii-text17">calitate</span>
              <br />
              <span class="arenda-spatii-text18">IN</span>
              <span class="arenda-spatii-text19">
                <span v-html="rawch37"></span>
              </span>
              <span class="arenda-spatii-text20">Moldova</span>
              <span class="arenda-spatii-text21"></span>
            </h1>
            <span class="arenda-spatii-text22">
              <span>N</span>
              <span class="arenda-spatii-text24">
                oi garantam executarea rapida și la un nivel
                <span v-html="rawzeo3"></span>
              </span>
              <br />
              <span class="arenda-spatii-text26">
                inalt a comenzilor Dvs.
                <span v-html="raw3p50"></span>
              </span>
            </span>
            <div class="arenda-spatii-btns-container1">
              <a
                href="#servicii"
                class="arenda-spatii-primary button-primary button-lg button"
              >
                servicii
              </a>
              <a
                href="#contacts"
                class="arenda-spatii-secondary button button-outline button-lg-border"
              >
                adresa noastra
              </a>
            </div>
          </div>
          <div class="arenda-spatii-video-container">
            <div class="arenda-spatii-container2"></div>
          </div>
        </div>
        <div class="arenda-spatii-blue-background"></div>
      </div>
      <div class="arenda-spatii-text-content">
        <h1 class="arenda-spatii-text27">Arenda Spatiilor</h1>
        <span class="arenda-spatii-text28">
          <span>
            Combinatul Auto Nr.4 din Chisinau
            <span v-html="rawx3ot"></span>
          </span>
          <br />
          <span></span>
          <span class="arenda-spatii-text32">
            ofera in locatiune, la preturi avantajoase:
            <span v-html="raw9r4h"></span>
          </span>
          <br />
          <span class="arenda-spatii-text33">-spatii pentru oficii</span>
          <br />
          <span class="arenda-spatii-text34">-spatii pentru depozit</span>
          <br />
          <span class="arenda-spatii-text35">
            -spatii pentru ateliere de service Auto
          </span>
          <br />
          <span class="arenda-spatii-text36">-spatii pentru parcari auto</span>
          <br />
          <span></span>
        </span>
      </div>
      <div class="arenda-spatii-speakers section-container">
        <div id="servicii" class="arenda-spatii-max-width2 max-content-container">
          <div class="arenda-spatii-speakers-container">
            <router-link to="/transport">
              <speaker-card
                role="livrare National"
                lastName="marfuri"
                firstName="Transport"
                imageSrc="/15-300h.webp"
                rootClassName="speaker-cardroot-class-name15"
                class="arenda-spatii-component11"
              ></speaker-card>
            </router-link>
            <router-link to="/reparatii-auto">
              <speaker-card
                role="servicii electrice si mecanice"
                lastName="auto"
                firstName="reparatii"
                imageSrc="/16-300h-300h.webp"
                class="arenda-spatii-component12"
              ></speaker-card>
            </router-link>
            <speaker-card
              role="rapid si calitativ"
              lastName="auto"
              firstName="spalatorie"
              imageSrc="/14-300h.webp"
            ></speaker-card>
            <router-link to="/parcare-auto">
              <speaker-card
                role="siguranta maxima"
                lastName="auto"
                firstName="parcare"
                imageSrc="/13-300h.webp"
                class="arenda-spatii-component14"
              ></speaker-card>
            </router-link>
            <router-link to="/arenda-spatii">
              <speaker-card
                role="siguranta maxima"
                lastName="spatiilor"
                firstName="arenda"
                imageSrc="/12-300h.webp"
                class="arenda-spatii-component15"
              ></speaker-card>
            </router-link>
            <router-link to="/alimentarea-publica">
              <speaker-card
                role="servicii de alimentatie (cantina)"
                lastName="publica"
                firstName="alimentatie"
                imageSrc="/cantina-300w.webp"
                class="arenda-spatii-component16"
              ></speaker-card>
            </router-link>
            <speaker-card
              role="in curind"
              lastName="noi"
              firstName="servicii "
              imageSrc="https://images.unsplash.com/photo-1620673504048-d2899f20de1c?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDF8fG1vbGRvdmF8ZW58MHx8fHwxNjUwMzExNzE3&amp;ixlib=rb-1.2.1&amp;h=300"
              rootClassName="speaker-cardroot-class-name16"
            ></speaker-card>
            <speaker-card
              role="in curind ..."
              lastName="noi"
              firstName="servicii"
              imageSrc="/rm-300h.webp"
              rootClassName="speaker-cardroot-class-name17"
            ></speaker-card>
          </div>
        </div>
      </div>
      <div class="arenda-spatii-numbers-banner section-container">
        <div class="arenda-spatii-container3 max-content-container">
          <div class="arenda-spatii-heading-container1">
            <span class="arenda-spatii-text38">
              Personalul intreprinderii reprezinta o echipa profesionista, cu
              experienta vasta in domeniu.
              <span v-html="rawli4z"></span>
            </span>
            <h1 class="arenda-spatii-text39 Heading2">
              <span>
                servicii la preturi accesibile
                <span v-html="raw0ato"></span>
              </span>
            </h1>
          </div>
          <div class="arenda-spatii-numbers-container">
            <numbers-card text="expeditiii"></numbers-card>
            <numbers-card
              text="ani"
              number="12"
              imageSrc="/interface%20time%20reset-200h.webp"
            ></numbers-card>
            <numbers-card
              text="evenimente"
              number="64"
              imageSrc="/interface%20calendar%20favorite-200h.webp"
            ></numbers-card>
            <numbers-card
              text="companii"
              number="234"
              imageSrc="/shopping%20bag%20suit%20case-200h.webp"
            ></numbers-card>
            <numbers-card
              text="orase"
              number="14"
              imageSrc="/travel%20map%20location%20pin-200h.webp"
            ></numbers-card>
            <numbers-card
              text="diagnosticari"
              number="1,071"
              imageSrc="/interface%20time%20reset-200h.webp"
            ></numbers-card>
          </div>
        </div>
      </div>
      <div class="arenda-spatii-location">
        <img
          id="news"
          alt="image"
          src="https://images.unsplash.com/photo-1618312980096-873bd19759a0?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDd8fGF1dG8lMjByZXBhaXJ8ZW58MHx8fHwxNjUwMzA4OTI0&amp;ixlib=rb-1.2.1&amp;w=1500"
          class="arenda-spatii-image"
        />
        <div class="arenda-spatii-content-container2 section-container">
          <div class="arenda-spatii-container4">
            <span class="arenda-spatii-text41">REPARAtIE AUTO</span>
            <span class="arenda-spatii-text42">Calitativ</span>
            <div class="arenda-spatii-container5">
              <span class="arenda-spatii-text43"><span>motoare</span></span>
              <span class="arenda-spatii-text45"><span>caroserii</span></span>
              <span class="arenda-spatii-text47"><span>diagnosticare</span></span>
            </div>
            <div class="arenda-spatii-container6">
              <span class="arenda-spatii-text49">
                oferim servicii de reparație auto
              </span>
              <span class="arenda-spatii-text50">
                <span>
                  la toate tipurile de mașini, secția reparații este dotată cu
                  mecanisme care ne permit a efectua reparații auto calitative și
                  anume: motoare, caroserii, sisteme de transmisie, sisteme de
                  control, sisteme hidraulice, acumulatoare, radiatoare, sisteme
                  de încălzire, sisteme de răcire, sisteme de frînare.
                  <span v-html="rawk73d"></span>
                </span>
                <br />
                <span>
                  Identificăm cele mai complexe defecțiuni prin diagnosticarea
                  computerizată.
                  <span v-html="rawkmfi"></span>
                </span>
              </span>
              <div class="arenda-spatii-btns-container2">
                <a
                  href="#contacts"
                  class="arenda-spatii-register button-secondary button button-md"
                >
                  programeaza-te
                </a>
                <a
                  href="#contacts"
                  class="arenda-spatii-learn-more button button-outline button-md-border"
                >
                  adresa
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="arenda-spatii-agenda section-container">
        <div id="contacts" class="arenda-spatii-max-width3 max-content-container">
          <div class="arenda-spatii-heading-container2">
            <h1 id="contact" class="arenda-spatii-text54 Heading2">
              <span>ADRESA NOASTRA</span>
            </h1>
            <span class="arenda-spatii-text56">
              te asteptam sa testezi serviciile noastre
            </span>
          </div>
        </div>
      </div>
      <div class="arenda-spatii-workshops">
        <div class="arenda-spatii-content-container3">
          <div class="arenda-spatii-container7">
            <h1 class="arenda-spatii-text57 Heading2">
              <span>contacte</span>
              <br />
              <span class="arenda-spatii-text60">
                MD-2002
                <span v-html="raw4qfa"></span>
              </span>
              <span><span v-html="rawwn3d"></span></span>
              <span>MUN.CHIsINaU, STR.PaDURII 13</span>
            </h1>
            <span class="arenda-spatii-text63">
              ----------------------------------------------
            </span>
            <span class="arenda-spatii-text64">
              <span></span>
              <br />
              <span>MobILE:</span>
              <span class="arenda-spatii-text67">
                <span v-html="rawecwz"></span>
              </span>
              <span class="arenda-spatii-text68">
                (+373)
                <span v-html="rawnnai"></span>
              </span>
              <a href="tel:37369322886">
                <span class="arenda-spatii-text69">69322886</span>
              </a>
              <span class="arenda-spatii-text70"></span>
              <br />
              <span>
                Tel/Fax: (+373)
                <span v-html="raw1u8u"></span>
              </span>
              <a href="tel:37322521144">
                <span class="arenda-spatii-text72">22521144</span>
              </a>
              <br />
              <span></span>
              <br />
              <span></span>
              <a href="mailto:COMBINATAUTO@GMAIL.COM?subject=email">
                <span class="arenda-spatii-text76">Combinatauto@gmail.com</span>
              </a>
              <span class="arenda-spatii-text77"></span>
              <span class="arenda-spatii-text78"></span>
              <span class="arenda-spatii-text79"></span>
              <span><span v-html="rawsevx"></span></span>
              <br />
              <span></span>
              <a href="mailto:DSACA4@MAIL.RU?subject=">
                <span class="arenda-spatii-text82">dsaca4@mail.ru</span>
                <br class="arenda-spatii-br20" />
              </a>
            </span>
          </div>
        </div>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1361.1581244223369!2d28.896054673961334!3d46.97512272089735!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40c9796e1caa0069%3A0x18af5b1f21321713!2sSA%20Combinatul%20Auto%20nr.4%2C%20Chi%C8%99in%C4%83u!5e0!3m2!1sro!2s!4v1650529500065!5m2!1sro!2s"
          title="maps"
          class="arenda-spatii-iframe"
        ></iframe>
      </div>
      <div class="arenda-spatii-previous-events section-container">
        <div class="arenda-spatii-max-width4 max-content-container">
          <div class="arenda-spatii-heading-container3">
            <h1 class="arenda-spatii-text83 Heading2">
              <span>PARTENERUL TAU DE INCREDERE</span>
            </h1>
            <span class="arenda-spatii-text85">
              garantam executarea rapida si calitativa a comenzilor Dumneavoastra
            </span>
          </div>
        </div>
      </div>
    </main>
    <app-footer rootClassName="footerroot-class-name10"></app-footer>
  </div>
</template>

<script>
import AppNavigation from '../components/navigation'
import SpeakerCard from '../components/speaker-card'
import NumbersCard from '../components/numbers-card'
import AppFooter from '../components/footer'

export default {
  name: 'ArendaSpatii',
  props: {},
  components: {
    AppNavigation,
    SpeakerCard,
    NumbersCard,
    AppFooter,
  },
  data() {
    return {
      rawaiyu: ' ',
      raw82ll: ' ',
      rawch37: ' ',
      rawzeo3: ' ',
      raw3p50: ' ',
      rawx3ot: ' ',
      raw9r4h: ' ',
      rawli4z: ' ',
      raw0ato: ' ',
      rawk73d: ' ',
      rawkmfi: ' ',
      raw4qfa: ' ',
      rawwn3d: ' ',
      rawecwz: ' ',
      rawnnai: ' ',
      raw1u8u: ' ',
      rawsevx: ' ',
    }
  },
  metaInfo: {
    title: 'Arenda-spatii - SA Combinatul Auto Nr.4 din Chișinău',
    meta: [
      {
        name: 'description',
        content:
          'SA Combinatul Auto Nr.4 din Chișinău, oferă o gamă largă de servicii electrice și mecanice la prețuri accesibile pentru fiecare.',
      },
      {
        property: 'og:title',
        content: 'Arenda-spatii - SA Combinatul Auto Nr.4 din Chișinău',
      },
      {
        property: 'og:description',
        content:
          'SA Combinatul Auto Nr.4 din Chișinău, oferă o gamă largă de servicii electrice și mecanice la prețuri accesibile pentru fiecare.',
      },
      {
        property: 'og:image',
        content:
          'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/7df3687e-9d61-4851-bd9b-b6ae978e2570/ea494eb0-6cf8-464c-b070-cddce041bc5c?org_if_sml=1&q=80&force_format=original',
      },
    ],
  },
}
</script>

<style scoped>
.arenda-spatii-container1 {
  width: 100%;
  display: flex;
  position: relative;
  min-height: 100vh;
  overflow-x: hidden;
  align-items: center;
  flex-direction: column;
}
 
.arenda-spatii-main {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
 
.arenda-spatii-hero {
  position: relative;
  padding-top: 128px;
}
 
.arenda-spatii-max-width1 {
  z-index: 1;
  align-items: stretch;
}
 
.arenda-spatii-content-container1 {
  flex: 1;
  display: flex;
  max-width: 45%;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
}
 
.arenda-spatii-text10 {
  font-size: 60px;
  font-style: normal;
  font-family: IBM Plex Sans Condensed;
  font-weight: 700;
  line-height: 1.1;
  margin-bottom: var(--dl-space-space-unit);
  text-transform: uppercase;
  text-decoration: none;
}
 
.arenda-spatii-text12 {
  text-transform: lowercase;
}
 
.arenda-spatii-text14 {
  color: var(--dl-color-scheme-pink);
}
 
.arenda-spatii-text15 {
  color: var(--dl-color-scheme-pink);
  text-transform: lowercase;
}
 
.arenda-spatii-text17 {
  color: var(--dl-color-scheme-pink);
  text-transform: lowercase;
}
 
.arenda-spatii-text18 {
  font-style: normal;
  font-weight: 600;
  text-transform: lowercase;
}
 
.arenda-spatii-text19 {
  font-style: normal;
  font-weight: 600;
}
 
.arenda-spatii-text20 {
  font-style: normal;
  font-weight: 600;
  text-transform: capitalize;
}
 
.arenda-spatii-text21 {
  font-style: normal;
  font-weight: 600;
}
 
.arenda-spatii-text22 {
  font-style: normal;
  font-weight: 500;
  margin-bottom: 42px;
}
 
.arenda-spatii-text24 {
  text-transform: lowercase;
}
 
.arenda-spatii-text26 {
  text-transform: lowercase;
}
 
.arenda-spatii-btns-container1 {
  flex: 0 0 auto;
  display: flex;
  align-items: flex-start;
}
 
.arenda-spatii-primary {
  margin-right: var(--dl-space-space-oneandhalfunits);
  text-decoration: none;
}
 
.arenda-spatii-secondary {
  text-decoration: none;
}
 
.arenda-spatii-video-container {
  flex: 1;
  width: 200px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
}
 
.arenda-spatii-container2 {
  width: 100%;
  height: 511px;
  display: flex;
  transition: 0.3s;
  background-size: cover;
  background-image: url("/home-600h.webp");
  background-position: center;
}
 
.arenda-spatii-container2:hover {
  transform: scale(1.02);
  box-shadow: 5px 5px 10px 0px rgba(111, 102, 102, 0.31);
}
 
.arenda-spatii-blue-background {
  top: 0px;
  right: 0px;
  width: 47%;
  height: 100px;
  position: absolute;
  min-height: 80%;
  background-size: cover;
  background-image: url("/blue-bg-1500w.webp");
  background-repeat: no-repeat;
}
 
.arenda-spatii-text-content {
  width: 100%;
  display: flex;
  align-items: center;
  padding-top: var(--dl-space-space-twounits);
  padding-left: var(--dl-space-space-threeunits);
  padding-right: var(--dl-space-space-threeunits);
  flex-direction: column;
  padding-bottom: var(--dl-space-space-oneandhalfunits);
  justify-content: space-between;
}
 
.arenda-spatii-text27 {
  font-size: 3rem;
  text-align: center;
}
 
.arenda-spatii-text28 {
  max-width: var(--dl-size-size-maxwidth);
  margin-top: var(--dl-space-space-twounits);
  text-align: center;
  margin-bottom: var(--dl-space-space-twounits);
}
 
.arenda-spatii-text32 {
  text-transform: lowercase;
}
 
.arenda-spatii-text33 {
  text-transform: lowercase;
}
 
.arenda-spatii-text34 {
  text-transform: lowercase;
}
 
.arenda-spatii-text35 {
  text-transform: lowercase;
}
 
.arenda-spatii-text36 {
  text-transform: lowercase;
}
 
.arenda-spatii-speakers {
  display: flex;
  padding-top: var(--dl-space-space-threeunits);
  flex-direction: column;
}
 
.arenda-spatii-max-width2 {
  flex-direction: column;
}
 
.arenda-spatii-speakers-container {
  width: 100%;
  display: grid;
  grid-row-gap: var(--dl-space-space-fourunits);
  grid-column-gap: 30px;
  grid-template-columns: 1fr 1fr 1fr 1fr;
}
 
.arenda-spatii-component11 {
  text-decoration: none;
}
 
.arenda-spatii-component12 {
  text-decoration: none;
}
 
.arenda-spatii-component14 {
  text-decoration: none;
}
 
.arenda-spatii-component15 {
  text-decoration: none;
}
 
.arenda-spatii-component16 {
  text-decoration: none;
}
 
.arenda-spatii-numbers-banner {
  display: flex;
  padding-top: var(--dl-space-space-fiveunits);
  flex-direction: column;
  background-size: cover;
  background-image: url("/29bg-1500w.webp");
}
 
.arenda-spatii-container3 {
  flex-direction: column;
}
 
.arenda-spatii-heading-container1 {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  margin-bottom: var(--dl-space-space-fourunits);
  flex-direction: column;
}
 
.arenda-spatii-text38 {
  color: var(--dl-color-scheme-white);
  font-style: normal;
  text-align: center;
  font-weight: 500;
}
 
.arenda-spatii-text39 {
  color: var(--dl-color-scheme-white);
  text-align: center;
}
 
.arenda-spatii-numbers-container {
  width: 100%;
  display: grid;
  grid-row-gap: var(--dl-space-space-fourunits);
  grid-column-gap: 30px;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
}
 
.arenda-spatii-location {
  width: 100%;
  display: flex;
  align-items: stretch;
  flex-direction: row;
}
 
.arenda-spatii-image {
  width: 55%;
  max-height: 950px;
  object-fit: cover;
}
 
.arenda-spatii-content-container2 {
  flex: 1;
  display: flex;
  align-items: stretch;
  padding-top: 100px;
  padding-right: var(--dl-space-space-threeunits);
  flex-direction: row;
  background-color: var(--dl-color-scheme-black);
}
 
.arenda-spatii-container4 {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
 
.arenda-spatii-text41 {
  color: var(--dl-color-scheme-white);
  font-size: 56px;
  font-style: normal;
  font-weight: 600;
  line-height: 1.1;
  margin-left: -100px;
  padding-top: 4px;
  padding-left: 18px;
  margin-bottom: 6px;
  padding-right: 11px;
  padding-bottom: 6px;
  background-color: var(--dl-color-scheme-lightblue);
}
 
.arenda-spatii-text42 {
  color: var(--dl-color-scheme-white);
  font-size: 56px;
  font-style: normal;
  font-weight: 300;
  line-height: 1.1;
}
 
.arenda-spatii-container5 {
  display: flex;
  align-items: flex-end;
  margin-bottom: var(--dl-space-space-twounits);
  flex-direction: column;
}
 
.arenda-spatii-text43 {
  color: var(--dl-color-scheme-pink);
  font-size: 56px;
  font-style: normal;
  font-weight: 600;
  line-height: 1.1;
  margin-left: var(--dl-space-space-fiveunits);
}
 
.arenda-spatii-text45 {
  color: var(--dl-color-scheme-pink);
  font-size: 56px;
  font-style: normal;
  font-weight: 600;
  line-height: 1.1;
  margin-left: -36px;
}
 
.arenda-spatii-text47 {
  color: var(--dl-color-scheme-pink);
  font-size: 56px;
  font-style: normal;
  font-weight: 600;
  line-height: 1.1;
  margin-left: var(--dl-space-space-fiveunits);
}
 
.arenda-spatii-container6 {
  flex: 1;
  width: 100%;
  display: flex;
  max-width: 350px;
  align-items: flex-start;
  margin-left: 124px;
  flex-direction: column;
}
 
.arenda-spatii-text49 {
  color: var(--dl-color-scheme-white);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  margin-bottom: var(--dl-space-space-halfunit);
}
 
.arenda-spatii-text50 {
  color: var(--dl-color-scheme-white);
  text-align: justify;
  margin-bottom: var(--dl-space-space-twounits);
  text-transform: none;
}
 
.arenda-spatii-btns-container2 {
  flex: 0 0 auto;
  display: flex;
  align-items: flex-start;
}
 
.arenda-spatii-register {
  text-decoration: none;
}
 
.arenda-spatii-learn-more {
  color: var(--dl-color-scheme-white);
  transition: 0.3s;
  border-color: var(--dl-color-scheme-white);
  text-decoration: none;
}
 
.arenda-spatii-learn-more:hover {
  border-color: var(--dl-color-scheme-pink);
}
 
.arenda-spatii-agenda {
  display: flex;
  padding-top: var(--dl-space-space-fourunits);
  flex-direction: column;
  padding-bottom: 0px;
}
 
.arenda-spatii-max-width3 {
  flex-direction: column;
}
 
.arenda-spatii-heading-container2 {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  margin-bottom: var(--dl-space-space-fourunits);
  flex-direction: column;
}
 
.arenda-spatii-text54 {
  text-align: center;
}
 
.arenda-spatii-text56 {
  color: var(--dl-color-scheme-darkgray);
  font-style: normal;
  text-align: center;
  font-weight: 500;
}
 
.arenda-spatii-workshops {
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: row;
}
 
.arenda-spatii-content-container3 {
  flex: 1;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  justify-content: center;
  background-color: rgba(144, 149, 167, 0.08);
}
 
.arenda-spatii-container7 {
  flex: 0 0 auto;
  display: flex;
  max-width: 366px;
  align-items: flex-start;
  margin-right: 107px;
  flex-direction: column;
}
 
.arenda-spatii-text57 {
  margin-bottom: 42px;
}
 
.arenda-spatii-text60 {
  color: var(--dl-color-scheme-pink);
}
 
.arenda-spatii-text63 {
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  margin-bottom: var(--dl-space-space-halfunit);
}
 
.arenda-spatii-text64 {
  font-size: 20px;
  font-style: normal;
  text-align: justify;
  font-family: IBM Plex Sans Condensed;
  font-weight: 600;
  line-height: 1.3;
  margin-bottom: var(--dl-space-space-threeunits);
  letter-spacing: 0.02em;
  text-transform: uppercase;
  text-decoration: none;
}
 
.arenda-spatii-text67 {
  font-weight: 700;
}
 
.arenda-spatii-text68 {
  font-weight: 700;
}
 
.arenda-spatii-text69 {
  font-weight: 700;
  text-decoration: underline;
}
 
.arenda-spatii-text70 {
  font-weight: 700;
  text-decoration: underline;
}
 
.arenda-spatii-text72 {
  text-decoration: underline;
}
 
.arenda-spatii-text76 {
  text-decoration: underline;
}
 
.arenda-spatii-text77 {
  text-decoration: underline;
}
 
.arenda-spatii-text78 {
  text-decoration: underline;
}
 
.arenda-spatii-text79 {
  text-decoration: underline;
}
 
.arenda-spatii-text82 {
  text-decoration: underline;
}
 
.arenda-spatii-br20 {
  text-decoration: underline;
}
 
.arenda-spatii-iframe {
  width: 50%;
  min-height: 880px;
}
 
.arenda-spatii-previous-events {
  display: flex;
  position: relative;
  flex-direction: column;
  padding-bottom: 150px;
}
 
.arenda-spatii-max-width4 {
  flex-direction: column;
}
 
.arenda-spatii-heading-container3 {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  margin-bottom: var(--dl-space-space-fourunits);
  flex-direction: column;
}
 
.arenda-spatii-text83 {
  text-align: center;
}
 
.arenda-spatii-text85 {
  color: var(--dl-color-scheme-darkgray);
  font-style: normal;
  text-align: center;
  font-weight: 500;
}
 
@media(max-width: 991px) {
  .arenda-spatii-max-width1 {
    flex-direction: column;
  }
  .arenda-spatii-content-container1 {
    max-width: 100%;
    margin-bottom: 42px;
  }
  .arenda-spatii-container2 {
    width: 583px;
  }
  .arenda-spatii-blue-background {
    top: auto;
    width: 100%;
    bottom: 0px;
    min-height: 40%;
  }
  .arenda-spatii-text28 {
    max-width: 100%;
  }
  .arenda-spatii-speakers-container {
    grid-template-columns: 1fr 1fr 1fr;
  }
  .arenda-spatii-numbers-container {
    grid-template-columns: 1fr 1fr 1fr;
  }
  .arenda-spatii-location {
    flex-direction: column;
  }
  .arenda-spatii-image {
    width: 100%;
  }
  .arenda-spatii-content-container2 {
    padding-top: 0px;
    padding-left: var(--dl-space-space-threeunits);
  }
  .arenda-spatii-container4 {
    margin-top: -100px;
    align-items: center;
  }
  .arenda-spatii-container6 {
    max-width: 100%;
    margin-left: 0px;
  }
  .arenda-spatii-container7 {
    margin-right: var(--dl-space-space-unit);
  }
  .arenda-spatii-iframe {
    width: 50%;
    min-height: 600px;
  }
}
 
@media(max-width: 767px) {
  .arenda-spatii-container2 {
    width: 505px;
  }
  .arenda-spatii-text-content {
    padding-left: var(--dl-space-space-twounits);
    padding-right: var(--dl-space-space-twounits);
  }
  .arenda-spatii-text28 {
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
  }
  .arenda-spatii-speakers-container {
    grid-template-columns: 1fr 1fr;
  }
  .arenda-spatii-numbers-container {
    grid-template-columns: 1fr 1fr;
  }
  .arenda-spatii-image {
    max-height: 100%;
  }
  .arenda-spatii-content-container2 {
    padding-left: var(--dl-space-space-twounits);
    padding-right: var(--dl-space-space-twounits);
  }
  .arenda-spatii-text41 {
    margin-left: -24px;
  }
  .arenda-spatii-btns-container2 {
    width: 100%;
    align-items: stretch;
    flex-direction: column;
  }
  .arenda-spatii-workshops {
    flex-direction: column-reverse;
    padding-bottom: var(--dl-space-space-twounits);
  }
  .arenda-spatii-container7 {
    max-width: 100%;
    padding-top: var(--dl-space-space-twounits);
    margin-right: 0px;
    padding-left: var(--dl-space-space-oneandhalfunits);
    padding-right: var(--dl-space-space-oneandhalfunits);
    padding-bottom: var(--dl-space-space-twounits);
  }
  .arenda-spatii-iframe {
    width: 100%;
  }
  .arenda-spatii-previous-events {
    padding-bottom: var(--dl-space-space-sixunits);
  }
}
 
@media(max-width: 479px) {
  .arenda-spatii-text10 {
    font-size: 60px;
  }
  .arenda-spatii-container2 {
    width: 424px;
  }
  .arenda-spatii-text-content {
    padding-top: var(--dl-space-space-twounits);
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
    padding-bottom: var(--dl-space-space-twounits);
  }
  .arenda-spatii-speakers-container {
    grid-template-columns: 1fr;
  }
  .arenda-spatii-text43 {
    font-size: 50px;
    margin-right: var(--dl-space-space-oneandhalfunits);
  }
  .arenda-spatii-text45 {
    font-size: 50px;
    margin-right: var(--dl-space-space-oneandhalfunits);
  }
  .arenda-spatii-text47 {
    font-size: 50px;
    margin-left: var(--dl-space-space-oneandhalfunits);
    margin-right: var(--dl-space-space-oneandhalfunits);
  }
  .arenda-spatii-text50 {
    text-align: justify;
  }
}
</style>
